// mock api
// import './_apis_';
// highlight
import './utils/highlight';
// scroll bar
import 'simplebar/src/simplebar.css';
// map
import 'mapbox-gl/dist/mapbox-gl.css';
// lightbox
import 'react-image-lightbox/style.css';
// editor
import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// lazy image
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';

import { PersistGate } from 'redux-persist/lib/integration/react';
// material for date picker
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// redux
import { store, persistor } from './redux/store';
// contexts
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
// components
import LoadingScreen from './components/LoadingScreen';
import { AuthProvider } from './contexts/JWTContext';
//
import App from './App';
import reportWebVitals from './reportWebVitals';
// import ReduxThunkProvider from './redux';
// ----------------------------------------------------------------------

ReactDOM.render(
  <HelmetProvider>
    {/* <ReduxThunkProvider> */}
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <CollapseDrawerProvider>
          <BrowserRouter>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <AuthProvider>
                <App />
              </AuthProvider>
            </LocalizationProvider>
          </BrowserRouter>
        </CollapseDrawerProvider>
      </PersistGate>
    </ReduxProvider>
    {/* </ReduxThunkProvider> */}
  </HelmetProvider>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
